export default "__VITE_ASSET__CLMhiXqZ__"